<template>
  <v-container>
    <h3 class="page-title">可篩檢快查</h3>
    <v-row>
      <v-col>
        <v-text-field
          label="身分證字號"
          v-model="id"
          append-icon="mdi-barcode-scan"
          @click:append="check"
          @keydown.enter="check"
          outlined
          dense
          hide-details
          clearable
        >
        </v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          label="出生年月日(不在藉或 40 歲以下需填寫)"
          v-model="birth"
          outlined
          dense
          hide-details
          clearable
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="result && id">
      <v-col>
        <v-card>
          <v-card-title class="text-h6">
            {{ this.id }} 今年可檢查項目
          </v-card-title>
          <v-card-text>
            <v-alert v-if="!this.性別" color="error" dark class="text-center">
              注意！民眾不在藉或 40 歲以下，請填寫出生年月日後重新查詢！
            </v-alert>
            <div
              class="text-body-1 mb-2 font-weight-bold"
              v-for="key of [
                '成健',
                'BC肝',
                '乳攝',
                '口腔',
                '大腸',
                '胃篩',
                '子抹',
                'LDCT',
                'HPV',
                'ICOPE',
              ]"
            >
              {{ key }}
              <span class="success--text" v-if="item(key)">可執行</span>
              <span class="error--text" v-else>
                不可執行<template v-if="key === '成健' && result.P4P">（P4P 照護個案）</template>
                <template
                  v-if="prev[key] && (prev[key].時間 || prev[key].單位)"
                >
                  （{{ prev[key].時間 || "" }} {{ prev[key].單位 || "" }}）
                </template>
              </span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import barcodeReader from "@wrurik/barcode-scanner";
import dayjs from "dayjs";
export default {
  name: "QuickCheck",
  data: () => ({
    id: null,
    birth: null,
    cancelScan: null,
    result: null,
    prev: null,
    性別: "",
    姓名: "",
  }),
  async created() {
    this.cancelScan = barcodeReader.onScan(this.scanHandler, {
      scanDuration: 500,
    });
  },
  beforeDestroy() {
    this.cancelScan();
  },
  methods: {
    item(item) {
      let result = false;
      switch (item) {
        case "成健":
          // result = this.result.成健名單 && !this.prev[item].時間;
          result = !this.result.P4P && this.result.成健名單;
          break;
        case "BC肝":
          // result = this.result.BC肝名單 && !this.prev[item].時間;
          result = this.result.BC肝名單;
          break;
        case "乳攝":
          result =
            this.result.乳攝名單 &&
            !this.result.乳攝已篩 &&
            // !this.prev[item].時間 &&
            this.性別 == "女";
          break;
        case "口腔":
          result = this.result.口腔名單 && !this.result.口腔已篩;
          // !this.prev[item].時間;
          break;
        case "大腸":
          result = this.result.大腸名單 && !this.result.大腸已篩;
          // !this.prev[item].時間;
          break;
        case "胃篩":
          result = this.result.胃篩名單 && !this.result.胃篩已篩;
          break;
        case "子抹":
          result =
            this.result.戶政名單 && !this.result.子抹已篩 && this.性別 == "女";
          break;
        // ANCHOR quickCheck 快速篩檢
        case "LDCT":
          result = this.result.LDCT名單 && !this.result.LDCT已篩;
          break;
        case "HPV":
          result = this.result.HPV名單 && !this.result.HPV已篩;
          break;
        case "ICOPE":
          result = this.result.ICOPE名單 && !this.result.ICOPE已篩;
          break;
      }

      return result;
    },
    async scanHandler(value, e) {
      if (!value) return;
      value = value.toUpperCase();
      if (
        // document.activeElement.id != "keyword" &&
        /^[A-Z](1|2)\d{8}$/i.test(value) ||
        /\d{10}/.test(value)
      ) {
        this.id = value;
        let data = (
          await this.axios.get(`/dashboard/quickCheck/${this.id}`, {
            params: { birth: this.birth },
          })
        ).data;
        this.性別 = data.性別;
        this.result = data.名單;
        this.prev = data.前次;
        this.姓名 = data.姓名;
        this.queryVaccine(value);
      }
    },
    async check() {
      this.result = null;
      this.scanHandler(this.id);
    },
    async queryVaccine(id) {
      if (this.$city.name != "臺南市") {
        return;
      }
      let records = (
        await this.axios.get(`https://influenza.tncghb.gov.tw/api/niis/${id}`, {
          alone: true,
        })
      ).data;
      if (records) {
        // let sortRecords = _.sortBy(records, ["接種日期"]);
        let sortRecords = _.filter(sortRecords, (record) => {
          return record.疫苗劑別.includes("JN");
        });
        // sortRecords.reverse();

        // let record = sortRecords[0];
        // let date = parseInt(record.接種日期) + 19110000 + "";
        // let 劑別 = record.疫苗劑別.split("-")[1];
        // let 疫苗 = record.疫苗劑別.split("-")[0];

        if (!sortRecords.length) {
          this.$toast.warning("請鼓勵民眾施打 JN.1 疫苗！");
        }
      }
    },
  },
  watch: {
    birth() {
      this.result = null;
    },
  },
};
</script>

<style></style>
